export class BaseControl {
  isRendered = false;
  label = "";
  visible = true;
  enabled = true;
  required = false;
  validState = false;
  isPrint = false;
  isNotAForm;
  isLockedKey;
  presetValue = '';
  foreignRecord = {};
  emptyModel = { display: '', value: '' };
  containerIds = [];
  model;
  fieldSchema;
  constructor(BaseControlService, $scope) {
    'ngInject';
    this.bs = BaseControlService.BehaviorService;
    this.gl = BaseControlService.GeoLocationService;
    this.as = BaseControlService.ActionService;
    this.es = BaseControlService.EventService;
    this.ts = BaseControlService.TemplateService;
    this.rcs = BaseControlService.RecordService;
    this.tfs = BaseControlService.TypeFormatService;
    this.dom = BaseControlService.DomService;
    this.FF = BaseControlService.FORMAT_FUNCTIONS;
    this.$timeout = BaseControlService.$timeout;
    this.$scope = $scope;
    // handy for behavior testing:
    // setInterval(() => this.enabled = !this.enabled, 10000)
  }

  get isDynamic() {
    return this.template?.type == 'dynamic';
  }
  
  get isEmpty() {
    return angular.equals(this.model.value, this.emptyModel.value);
  }
  
  get referenceFieldId() {
    return `ref-${this.token.referenceId}-fid-${this.token.fieldId}`;
  }

  get $feControl() {
    this._$feControl = this._$feControl || $(`fe-control.token-id-${this.token?.id}`);
    return this._$feControl;
  }

  // Warning: angularjs won't do async call (may need refactor, for now using the baseOnInitDone flag as workaround)
  async $onInit() {
    const { isNotAForm, isSubmit, isUpdate, isPrinting } = this.as;
    this.PROVIDER = await this.ts.PROVIDER;
    this.isNotAForm = isNotAForm;
    const refId = this.token.referenceId;
    if (this.ts.template?.signTemplate === true && !this.isNotAForm) {
      this.isPrint = this.rcs.isRefPrint(refId);
      this.isSubmit = this.rcs.isRefSubmit(refId);
      this.isUpdate = this.rcs.isRefUpdate(refId);
    } else {
      this.isPrint = isPrinting;
      this.isUpdate = isUpdate;
      this.isSubmit = isSubmit;
    }
    try {
      this.fieldSchema = this.token.fieldSchema;
      this.template = this.ts.template;
      this.referenceFieldHash = this.token?.referenceId + "|" + this.token?.fieldId;
      this.isLockedKey = this.token.fieldSchema?.isPrimaryKey && !this.isSubmit;

      this.loadFormatter();
      this.initModel();

      this.setExtraProperties();
      this.setLabel();
      this.checkLogField();
      this.$scope.$apply(_ => this.initWatchers()); // setInitialModel watch was not triggering!
      await this.setInitialModel();

      await this.initializeControlData();

      this.notifyControlLoaded();

      // Not called automatically for temporary tokens (ie: report edit) when 'all controls loaded'
      if (this.token._temp) this.updateBehaviorsStatus();

      this.containerIds = !this.isDynamic ? []: 
        this.$feControl.parents('[data-block-id]').map(function () {
          return $(this).attr('data-block-id');
        }).get();

      this.baseOnInitDone = true;
      this.afterInit();
    } catch (error) {
      console.error(error);
    }
  }

  afterInit() {
    this.$scope.$evalAsync(() => { requestAnimationFrame(() => this.adjustFontToFit()) });
  }

  async setInitialModel() {
    if (this.isNotAForm) { 
      this.stdModel(this.presetValue); 
      return;
    }

    if (!this.isEmpty) return; // ie no model from provider

    this.applyDefaultValue();
    this.applyGeoData();
    this.applyPrefill();
    this.applyAutoKey();
  }
  
  loadFormatter() {
    this.token._formatter = this.tfs.getFormatter(this.fieldSchema);
  }

  setExtraProperties() {
    this.token._isBoolean = this.ts.tokenIsBoolean(this.PROVIDER, this.token);
  }

  initModel() {
    if (!Object.keys(this.model || {}).length) this.clearModel();
  }
  
  clearModel() {
    this.model = angular.copy(this.emptyModel);
  }

  onBeforeAction() {
    // Updates before running action (ie: geolocation)
    this.token.options?.geoData?.relocate && this.applyGeoData();
  }

  async initializeControlData() {}

  stdModel(newVal) {
    const { setter, getter } = this.token.control;
    try {
      if (arguments.length) {
        this.model.value = this.FF[setter](newVal, this.token);
        this.model.display = null;
        return this.model.value;
      } else {
        return this.FF[getter](this.model?.value, this.token);
      }
    } catch(e) {
      console.log(e);
    }

  }

  notifyControlLoaded(){
    this.validState = true; 
    this.subscribeEvents();
    this.es.dispatchEvent(this.es.actions.CONTROL_LOADED, this.token);
  }

  rendered() {
    this.isRendered = true;
  }

  setLabel() {
    this.label = (typeof this.token.options?.label === 'string' && !this.isNotAForm) // allows for empty label ''
      ? this.token.options?.label
      : this.fieldSchema?.label;
  }
  
  applyGeoData() {
    if (this.isPrint || this.isNotAForm) return;
    if (!this.token.options?.geoData?.type || this.gl.unavailable) return;

    const coordVal = this.gl.getCoordinate(this.token.options.geoData.type);
    if (coordVal === null) return;
    const formatter = this.token._formatter;
    const formattedCoordVal = formatter ? formatter.jsFloatToStr(coordVal) : coordVal.toString();
    this.stdModel(formattedCoordVal);
  }
  
  applyDefaultValue() {
    if (!this.isSubmit) return;
    const { defaultValue } = this.token.control;
    (defaultValue !== undefined) && this.stdModel(defaultValue);
  }
  
  applyPrefill() {
    if (this.isPrint || this.isNotAForm) return;
    const prefill = this.rcs.getPrefill(this.token.referenceId, this.token.fieldId);
    if (prefill?.value !== undefined) this.stdModel(prefill.value);
  }

  applyAutoKey() {
    if (!this.isSubmit || !this.token.options?.autoGenerateKey) return;
    if (this.isEmpty) {
      const newKey = this.ts.getNewObjectId();
      this.stdModel(newKey);
    }
  }
  
  checkLogField() {
    this.isUpdate && this.token.control.isAppendOnly && this.stdModel("");
  }

  initWatchers() {
    if (this.isPrint) return;
    if(this.token.control.foreignValue) {
      this.watchForeignValue();
    } else {
      this.watchModelValue();
    }
  }
  
  watchModelValue() {
    this.$scope.$watch("$ctrl.model.value", (newVal, oldVal) => {
      this.$timeout(_=> this.modelChanged(newVal, oldVal));
      if (!this.shouldApplyUpdate(newVal, oldVal)) return;
      this.$timeout(() => this.adjustFontToFit(), 100);

      this.model.display = null;
      const change = { token: this.token, model: this.model };
      this.es.dispatchEvent(this.es.actions.FIELD_UPDATED, change);
    });
  }

  modelChanged(_newVal, _oldVal) {
    this.es.dispatchEvent(this.es.actions.MODEL_UPDATED, null);
  }
  
  shouldApplyUpdate(newVal, oldVal) {
    return this.enabled && !this.isSame(newVal, oldVal);
  }
  
  watchForeignValue() {
    const { tableId, fieldId } = this.token.control.foreignValue;
    this.es.subscribeEvent(
      this.es.actions.FOREIGN_KEY_CHANGED, ({token, foreignRecord={}}) => {
        if (token.referenceId !== this.token.referenceId || this.token.fieldSchema.referencedFieldId !== token.fieldSchema.id) return;
        
        const {inheritedFields, tableId: fkTableId} = token.control.foreignKey;
        if (fkTableId === tableId && inheritedFields.includes(fieldId)) {
          this.foreignRecord = foreignRecord;
          const oldValue = this.model?.value;
          this.model = foreignRecord[fieldId] || angular.copy(this.emptyModel);
          this.modelChanged(this.model.value, oldValue);
          // Urgent patch for recordservice property shadowing / race conditions (don't remove):
          if (this.rcs?.records[this.token.referenceId])
            this.rcs.records[this.token.referenceId][this.token.fieldId] = this.model;
          this.$timeout(() => this.adjustFontToFit(), 100);
        }
      },
      'FOREIGN_KEY_CHANGED_FVALUE_' + this.token.id
    );
  }
  
  isSame(newVal, oldVal) {
    return `${oldVal}` === `${newVal}`;
  }

  adjustFontToFit() {
    if (this.isDynamic || !this.baseOnInitDone || !this.visible || !this.token?.options?.adjustFontToFit || !this.$feControl[0]) return;
    if (!/\bfont-size\s*:\s*[^;]*vw\b/i.test(this.token.layout || '')) return;
    const formControl = this.isPrint ? this.$feControl.find('.read-only')[0] : this.$feControl.find('input.form-control, textarea.form-control')[0];
    if (!formControl) return;
    const usePercentForFontSize = !this.as.isBackendCall && this.ts.template?.pageView === 'pageview';
    if (this.token.control?.type === 'textarea-control') {
      this.dom.adjustFontForTokenMultiline(formControl, usePercentForFontSize);
    } else {
      this.dom.adjustFontForToken(formControl, usePercentForFontSize);
    }
  }

  subscribeEvents() {
    this.es.subscribeEvent( // fires first on 'all controls loaded'
      this.es.actions.RECORDS_UPDATED,
      () => this.onRecordsChanged(),
      `RECORDS_UPDATED_${this.token.id}`
    );
  }

  /** BEHAVIORS */
  setVisible() {
    const wasVisible = this.visible;
    this.visible = this.isNotAForm ||
      (this.validState && this.bs.evalVisibleBehavior(this.token.id));

    if (this.isDynamic) {
      const containersVisible = !this.containerIds.length || this.containerIds.every(id => this.bs.evalVisibleBehavior(id));
      this.visible = this.visible && containersVisible;
      this.visible ? this.$feControl.show() : this.$feControl.hide();
    }

    if (!wasVisible && this.visible && !this.isDynamic && this.baseOnInitDone) {
      this.$timeout(() => this.adjustFontToFit(), 100);
    }
  }

  setEnabled() {
    const sessionEditable = this.ts.template?.signTemplate === true
      ? this.rcs.isRefEditable(this.token.referenceId)
      : this.as.isEditableAction;
    this.enabled = this.isNotAForm ||
      (!this.isLockedKey && this.visible
      && !this.fieldSchema?.isReadOnly
      && !this.token?.options?.readOnly
      && sessionEditable
      && this.bs.evalEnabledBehavior(this.token.id));
  }

  setRequired() {
    const refId = this.token?.referenceId;
    const enforceRequired = !refId || this.rcs.shouldEnforceRequiredFields(refId);
    this.required = !this.isNotAForm &&
      enforceRequired &&
      this.enabled &&
      (this.fieldSchema?.isRequired
      || this.token?.options?.require
      || this.bs.evalRequiredBehavior(this.token.id));
  }
  
  updateBehaviorsStatus() {
    this.setVisible();
    this.setEnabled();
    this.setRequired();
    this.updateControlStateClasses();
  }

  updateControlStateClasses() {
    this.setStateClass(this.visible, "fe-control-visible", "fe-control-invisible");
    this.setStateClass(this.enabled, "fe-control-enabled", "fe-control-disabled");
    this.setStateClass(this.required, "fe-control-required", "fe-control-unrequired");
    this.setStateClass(this.isEmpty, "fe-control-unset", "fe-control-set");
  }

  setStateClass(state, activeClass, inactiveClass) {
    this.$feControl.removeClass(state ? inactiveClass : activeClass);
    this.$feControl.addClass(state ? activeClass : inactiveClass);
  }
  
  /** END BEHAVIORS */
  
  refreshSignedRefModes() {
    if (this.ts.template?.signTemplate !== true || this.isNotAForm) return;
    const refId = this.token.referenceId;
    this.isPrint = this.rcs.isRefPrint(refId);
    this.isSubmit = this.rcs.isRefSubmit(refId);
    this.isUpdate = this.rcs.isRefUpdate(refId);
    this.isLockedKey = this.token.fieldSchema?.isPrimaryKey && !this.isSubmit;
  }

  onRecordsChanged() {
    this.refreshSignedRefModes();
    this.updateBehaviorsStatus();
  }
}
